import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=051f414f&scoped=true"
import script from "./AppSetting.vue?vue&type=script&lang=js"
export * from "./AppSetting.vue?vue&type=script&lang=js"
import style0 from "./AppSetting.vue?vue&type=style&index=0&id=051f414f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f414f",
  null
  
)

export default component.exports